import { Card, CardBody, Progress, Typography } from "@material-tailwind/react";
import SideBar from "../../components/sidebar.tsx/SideBar";
import IconBackground from "../../components/common/IconBackground";
import { GoArrowUpRight } from "react-icons/go";
import CreditCard from "./components/CreditCard";
import TransactionsCard from "./components/TransactionsCard";
import { apiDirect } from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import AuthService from "../../services/authService";
import { useQuery } from "react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";
import DefaultLoading from "../../components/common/DefaultLoading";
import walletResponse from "../../models/wallet/wallet";
import MakeTransfer from "../../components/wallet/MakeTransfer";
import ErrorLoadingState from "../../components/common/buttons/ErrorLoadingState";
import EnterTransferPin from "../../components/wallet/EnterTransferPin";

function Wallet() {
  const [, setErrorText] = useState<string | null>(null);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [openPinDialog, setOpenPinDialog] = useState(false);
  const [name, setName] = useState<string | undefined>(undefined);

  const { isLoading, data, error } = useQuery<walletResponse>(
    `getWallet`,
    () => {
      const user = AuthService.user?.data;
      const queryString = new URLSearchParams({
        phone: user!.phoneNumber,
        email: user!.email,
      }).toString();

      console.log(queryString);
      return apiDirect.get(`${ApiRoutes.getWallet}?${queryString}`);
    },
    {
      onError: (error) => {
        if ((error as { statusCode: number }).statusCode === 400) {
          navigate(routerPaths.createWallet);
        }
      },
      onSuccess: (data) => {
        setErrorText(null);
        console.log(data);
        if (data.data.statusMessage === "Successful, No Record Available") {
          navigate(routerPaths.createWallet);
        }
      },
    }
  );

  const { data: incomeData } = useQuery(
    `getIncomeExpense`,
    () => {
      const queryString = new URLSearchParams({
        walletId: data?.data.data.id ?? "",
      }).toString();

      console.log(queryString);
      return apiDirect.get(`${ApiRoutes.getIncomeExpense}?${queryString}`);
    },
    {
      enabled: data?.data.data.id !== undefined,
      onError: (error) => {
        console.log(error);
      },
      onSuccess: (data) => {
        setErrorText(null);
        console.log(data.data.data);
      },
    }
  );

  return (
    <div className="md:flex">
      <div className="bg-gray-100 h-full ">
        <SideBar />
      </div>
      <div className="flex-1 p-8 mt-6">
        {isLoading ? (
          <div className="flex items-center justify-center h-screen">
            <DefaultLoading />
          </div>
        ) : error ? (
          <div className="flex items-center justify-center h-screen">
            <ErrorLoadingState />
          </div>
        ) : (
          <>
            <Typography
              placeholder={undefined}
              className="text-3xl font-semibold"
            >
              Wallet
            </Typography>
            <Typography placeholder={undefined} className="my-4">
              Check your wallet balance here and transactions
            </Typography>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-20">
              <div>
                <Card
                  placeholder={undefined}
                  className="shadow-sm overflow-hidden"
                >
                  <CardBody placeholder={undefined}>
                    <Typography placeholder={undefined}>
                      Available Balance
                    </Typography>
                    <Typography
                      placeholder={undefined}
                      className="font-medium text-2xl text-black"
                    >
                      {data?.data.data.availableBalance}
                    </Typography>
                    <div className="flex mt-5 font-bold ">
                      {/* <div
                        className="grid place-items-center rounded-md mr-3"
                        onClick={() => setOpenDialog((prev) => !prev)}
                      >
                        <IconBackground
                          icon={<GoArrowDownLeft size={30} color="white" />}
                          backgroundColor="bg-black"
                        />
                        <Typography
                          placeholder={undefined}
                          className="text-sm font-medium text-black"
                        >
                          Withdraw
                        </Typography>
                      </div> */}
                      <MakeTransfer
                        open={openDialog}
                        openPinDialog={() => setOpenPinDialog((prev) => !prev)}
                        handleOpen={() => {
                          setOpenDialog((prev) => !prev);
                          setName(undefined);
                        }}
                        amount={data?.data.data.availableBalance}
                        name={name}
                        setName={(val) => {
                          setName(val);
                        }}
                      />

                      <EnterTransferPin
                        open={openPinDialog}
                        walletId={data!.data.data.id}
                        handleOpen={() => setOpenPinDialog((prev) => !prev)}
                      />

                      {/* <EnterTransferOtp
                        open={openOtpDialog}
                        handleOpen={() => setOpenOtpDialog((prev) => !prev)}
                      /> */}

                      <div
                        className="grid place-items-center rounded-md "
                        onClick={() => setOpenDialog((prev) => !prev)}
                      >
                        <IconBackground
                          icon={<GoArrowUpRight size={30} color="white" />}
                          backgroundColor="bg-[#1D1F2C]"
                        />
                        <Typography
                          placeholder={undefined}
                          className="text-sm font-medium text-black"
                        >
                          Withdraw
                        </Typography>
                      </div>
                    </div>
                    <hr className="border-t border-dotted border-black mt-10 w-full my-4 bg-red" />
                    <div className="flex justify-between items-center">
                      <Typography placeholder={undefined}>Spending</Typography>
                      {/* 
                      <DefaultDropDown
                        onchange={(e) => console.log(e)}
                        value="Monthly"
                      >
                        <option>Monthly</option>
                        <option>Weekly</option>
                      </DefaultDropDown> */}
                    </div>
                    <Progress
                      placeholder={undefined}
                      value={incomeData?.data.data.creditPercentage}
                      size="lg"
                      color="green"
                      className="bg-red-600 mt-5 w-full"
                    />
                    <div className="flex justify-between items-center">
                      <Typography placeholder={undefined}>Income</Typography>
                      <Typography placeholder={undefined}>Expense</Typography>
                    </div>
                  </CardBody>
                </Card>
              </div>
              <CreditCard accountNumber={data?.data.data.accountNumber} />
              <TransactionsCard />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Wallet;
